import React from "react";
import { FaPhone, FaWhatsapp } from "react-icons/fa"; // Import icons
import "./FloatingButtons.css"; // Import CSS for styling

const FloatingButtons = () => {
  return (
    <div className="floating-buttons">
      {/* Call Button */}
      <a
        href="tel:+917276445893"
        className="floating-button call-button"
        title="Call Now"
      >
        <FaPhone />
      </a>

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/917276445893"
        className="floating-button whatsapp-button"
        title="Chat on WhatsApp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default FloatingButtons;
